// extracted by mini-css-extract-plugin
module.exports = {"blogPostTags":"BlogPostTags_blogPostTags__D4Dgh","tags":"BlogPostTags_tags__CyhbA"};